// extracted by mini-css-extract-plugin
export default {"DocumentView":"DocumentFileView_DocumentView__oFauy","OpacityBreak":"DocumentFileView_OpacityBreak__maxl1"};